import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { unitMeasures } from '../../../helpers/adipiBackendUrl';
import { getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_UNITMEASURE,
  DELETE_UNITMEASURE,
  GET_UNITMEASURES,
  UPDATE_UNITMEASURE,
  UPDATE_UNITMEASURE_STATUS
} from "./actionTypes";
import {
  addUnitMeasureFail,
  addUnitMeasureSuccess,
  deleteUnitMeasureFail,
  deleteUnitMeasureSuccess,
  getUnitMeasuresFail,
  getUnitMeasuresSuccess,
  setState,
  updateUnitMeasureFail,
  updateUnitMeasureSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchUnitMeasures( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,unitMeasures, params.toString());
    yield put(setState(false))
    yield put(getUnitMeasuresSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getUnitMeasuresFail(error));
  }
}

function* updateUnitMeasure ({payload: unitMeasureObj }) {
  try {
    const { id, recordStatus, ...rest } = unitMeasureObj;
    yield call(patchApiCall, `${unitMeasures}/${id}`, rest);
    const response = yield call(getTable,`${unitMeasures}/${unitMeasureObj.id}`);
    yield put(updateUnitMeasureSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateUnitMeasureFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* updateUnitMeasureStatus ({payload: unitMeasureObj }) {
  try {
    const response = yield call(getTable,`${unitMeasures}/${unitMeasureObj.id}`);
    yield put(updateUnitMeasureSuccess(response));
  } catch (error) {
    yield put(updateUnitMeasureFail(error));
  }
}

function* deleteUnitMeasure ({payload: unitMeasureObj}) {
  try {
    yield put(deleteUnitMeasureSuccess(unitMeasureObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteUnitMeasureFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingUnitMeasure ({ payload: unitMeasure}) {
  try {
    const response = yield call(postApiCall, unitMeasures ,unitMeasure);
    console.log('Respuesta POST:', response)
    yield put(addUnitMeasureSuccess(response));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addUnitMeasureFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* unitMeasuresSaga() {
  yield takeEvery(GET_UNITMEASURES, fetchUnitMeasures);
  yield takeEvery(ADD_NEW_UNITMEASURE, postingUnitMeasure);
  yield takeEvery(UPDATE_UNITMEASURE, updateUnitMeasure);
  yield takeEvery(UPDATE_UNITMEASURE_STATUS, updateUnitMeasureStatus);
  yield takeEvery(DELETE_UNITMEASURE, deleteUnitMeasure);
}

export default unitMeasuresSaga;
